import { api } from "./client";

export interface AdminDirectoryUser {
  id: number;
  username: string;
  account_type: "admin";
  created_at: string;
  flight_count: number;
  last_flight_at: string | null;
}

export interface AdminDirectoryOut {
  admins: AdminDirectoryUser[];
  summary: {
    admins: number;
    active_admins: number;
  };
}

export interface CreateAdminPayload {
  username: string;
  password: string;
}

export interface CreatedAdmin {
  id: number;
  username: string;
  account_type: "admin";
  created_at: string;
}

export interface WebSocketMessageBundle {
  storage_key: string;
  user_id: number;
  key: string;
  info_history_count: number;
  flight_history_count: number;
}

export interface AdminWebSocketMessageListOut {
  storage_backend: string;
  total: number;
  page: number;
  page_size: number;
  page_count: number;
  items: WebSocketMessageBundle[];
}

export interface WebSocketMessageFilters {
  user_id?: number;
  key?: string;
  page?: number;
  page_size?: number;
}

export interface WebSocketMessageBundleSelector {
  user_id: number;
  key: string;
}

function buildQueryString(filters: WebSocketMessageFilters, includeLimit = true) {
  const qs = new URLSearchParams();
  if (filters.user_id !== undefined) qs.set("user_id", String(filters.user_id));
  if (filters.key) qs.set("key", filters.key);
  if (filters.page !== undefined) qs.set("page", String(filters.page));
  if (includeLimit && filters.page_size !== undefined) {
    qs.set("page_size", String(filters.page_size));
  }
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return suffix;
}

export function getAdmins() {
  return api.get<AdminDirectoryOut>("/api/admins");
}

export function createAdmin(payload: CreateAdminPayload) {
  return api.post<CreatedAdmin>("/api/admins", payload);
}

export function getWebSocketMessages(filters: WebSocketMessageFilters) {
  return api.get<AdminWebSocketMessageListOut>(
    `/api/admins/websocket-messages${buildQueryString(filters)}`,
  );
}

export function getWebSocketMessagesExportPath(bundle: WebSocketMessageBundleSelector) {
  return `/api/admins/websocket-messages/export${buildQueryString(bundle, false)}`;
}
